import { Box, BoxProps } from '@mui/material';
import { ReactNode } from 'react';
import { grey } from '@mui/material/colors';

interface Props extends BoxProps {
  children: ReactNode;
  deep?: 1 | 2 | 3 | 4 | 5;
}

const Frame = ({ children, deep, ...rest }: Props) => {
  return (
    <Box
      padding={2}
      {...rest}
      sx={{
        border: deep ? 'none' : `1px solid ${grey[300]}`,
        borderRadius: 2,
        backgroundColor: deep ? grey[`${deep}00`] : 'white',
        width: '100%',
        // height: '100%',
      }}
    >
      {children}
    </Box>
  );
};

export default Frame;
